import links from '@/assets/json/footer.json';

export default function useI18nMeta() {
  /********************
   * COMPOSITIONS      *
   ********************/
  const localePath = useLocalePath();
  const router = useRouter();
  const { $gettext, interpolate, $pgettext } = useGettext();
  const { locale } = useI18n();

  /********************
   * REFS & VARS       *
   ********************/
  const i18nTermsOfServiceLink = computed(() => {
    const text = $pgettext('Terms of Service Link Text', 'terms of service');
    const link = router.resolve(
      localePath({
        name: 'info-all',
        params: {
          all: links.termsOfServiceB2C[locale.value] || links.termsOfServiceB2C.en || links.termsOfServiceB2C.de || null,
        },
      }),
    );
    return `<a href="${link.href}" class="no-wrap" target="_blank" rel="noopener">${text}</a>`;
  });

  const i18nPrivacyPolicyLink = computed(() => {
    const text = $pgettext('Privacy Policy Link Text', 'privacy policy');
    const link = router.resolve(
      localePath({
        name: 'info-all',
        params: {
          all: links.footer.privacy[locale.value] || links.footer.privacy.en || links.footer.privacy.de || null,
        },
      }),
    );
    return `<a href="${link.href}" class="no-wrap" target="_blank" rel="noopener">${text}</a>`;
  });

  const i18nUploadPoliciesLink = computed(() => {
    const text = $pgettext('Upload Policies Link Text', 'upload policies');
    return `<a href="#policies" target="_blank" rel="noopener">${text}</a>`;
  });

  const i18AcceptTermsCheckboxText = computed(() => {
    const translated = $gettext(
      'By posting or uploading content, I acknowledge the %{termslink} and grant Camping.info a royalty-free, non-exclusive, pertaining, spatially and temporally unrestricted right to use, reproduce, edit, distribute, transmit and make publicly accessible the content for operating and advertising the services in all media.',
    );
    return interpolate(translated, { termslink: i18nTermsOfServiceLink.value }, true);
  });

  return {
    i18AcceptTermsCheckboxText,
    i18nUploadPoliciesLink,
    i18nPrivacyPolicyLink,
    i18nTermsOfServiceLink,
  };
}
